export function getMeetingDateStr(startTime: string): string {
  const date = new Date(startTime);
  return date.toDateString();
}

export const formatTime: (dateString: string) => string = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

export const getTodayDateStr: () => string = () => {
    const today = new Date();
    return today.toDateString();
}